import type { Member } from '@gonfalon/openapi/types';

import { isAdmin } from './isAdmin';
import { isOwner } from './isOwner';
import { isReader } from './isReader';
import { isWriter } from './isWriter';

/** Whether the member may be redirected to or submit the post-auth welcome survey. */
export function isEligibleWelcomeSurveyMember(member: Member | undefined) {
  if (!member || isReader(member)) {
    return false;
  }

  return isOwner(member) || isAdmin(member) || isWriter(member);
}
